module.exports = __webpack_public_path__ + "static/assignroles1-08e36d906a6bc98ac9ed8d36893c7a5b.png";